
exports.SETTINGS = {
  DEFAULT_PRICELIST: 'default_price_list',
  DEFAULT_CURRENCY: 'default_currency_code',
  INVENTORY_DEFINITION_SCHEMA: 'inventory_definition_schema',
  INVOICE_ID_APPEND: 'invoice_id_append',
  INVOICE_ID_NEXT_ID: 'invoice_id_next_id',
  INVOICE_COLUMN_SCHEMA: 'invoice_column_schema',
  SALES_COLUMN_SCHEMA: 'sales_column_schema',
}